module.exports = __webpack_public_path__ + "img/Token_p2.1132e97b.png";